import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="bg-rose-600 text-white py-2 px-4 sticky top-0 z-50 shadow-md" data-id="element-18">
      <div className="max-w-7xl mx-auto flex justify-center items-center text-sm md:text-base font-medium" data-id="element-19">
        <motion.div animate={{
        opacity: [1, 0.7, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="flex items-center" data-id="element-20">
          <Sparkles className="w-4 h-4 mr-2 text-gold-300" data-id="element-21" />
          <span data-id="element-22">
            🔥 Oferta especial por tiempo limitado — ¡Aprovechá ahora!
          </span>
          <Sparkles className="w-4 h-4 ml-2 text-gold-300" data-id="element-23" />
        </motion.div>
      </div>
    </div>;
}